(() => {
  function init(root = document) {
    const form = root.querySelector('#ActiviteaEventForm');
    if (!form || form.dataset.acReady) return;
    form.dataset.acReady = 'true';
    const select = form.querySelector('[data-experience]');
    const key = `activitea-inquiry:${window.location.pathname}`;
    if (!select) {
      try { sessionStorage.removeItem(key); } catch {}
      form.querySelector('[data-form-status]')?.focus();
      return;
    }
    const field = form.querySelector('[data-location-field]');
    const location = form.querySelector('[data-location-input]');
    const date = form.querySelector('#ac-date');
    const params = new URLSearchParams(window.location.search);
    const values = {'event-service': 'Event beverage service', 'space-rental': 'Café space rental'};

    let previous = null;
    try { previous = JSON.parse(sessionStorage.getItem(key)); } catch {}
    if (previous && Date.now() - previous.time < 1800000) {
      for (const [name,value] of Object.entries(previous.values || {})) {
        const input = Array.from(form.elements).find(el => el.name === name);
        if (input) input.value = value;
      }
    }
    if (!form.querySelector('[data-form-status]') && values[params.get('experience')]) select.value = values[params.get('experience')];
    function sync() {
      const offsite = select.value === 'Event beverage service';
      field.hidden = !offsite;
      location.required = offsite;
      location.disabled = !offsite;
    }
    const parts = new Intl.DateTimeFormat('en-CA', {timeZone:'America/Chicago',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
    const part = type => parts.find(item => item.type === type).value;
    date.min = `${part('year')}-${part('month')}-${part('day')}`;
    select.addEventListener('change',sync);
    form.addEventListener('submit', () => {
      const fields = ['contact[Experience]','contact[Preferred date]','contact[Estimated guest count]','contact[Event location]'];
      const values = {};
      for (const input of form.elements) if (fields.includes(input.name) && !input.disabled) values[input.name] = input.value;
      try { sessionStorage.setItem(key, JSON.stringify({time:Date.now(),values})); } catch {}
    });
    sync();
    form.querySelector('[data-form-status]')?.focus();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init()); else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
